<div *ngIf="caseType === 'event'">
  <app-summary-event [isDesktopDevice]='isDesktopDevice'></app-summary-event>
</div>

<div *ngIf="caseType === 'issue'">
  <app-summary-issue [isDesktopDevice]='isDesktopDevice'></app-summary-issue>
</div>

